<footer class="mt-20 d-flex justify-content-center mb-0" #custom>

   <div class="footer-w">
    
      <div [ngStyle]="{'display':  footerData.footer.partnersImages.length > 0 ? '' : 'none'}">
        @if(!isWebMobile){
          <div class="social-share-container mt-20" #customm  id="partnersImg">
            @for (partnerImg of footerData.footer.partnersImages; track partnerImg) {
              <img class="mx-10" [src]="partnerImg.path" alt=""
              [style.height]="
                footerData.domain === 'latinacalcio'
              ? '80px'
                : footerData.domain === 'parcoeldorado'
                ? '55px'
              : partnerImg.path === 'assets/images/custom-ecommerce-img/pescaracalcio/partnersImg/cata.png'
              ? '30px'
              : '25px'"
              >
            }
          </div>
        }@else {
          <swiper-container
          slides-per-view="1"
          pagination="true"
          class="social-share-container m-20 mt-30"
          style="height: 99px;"
          #customm>
            @for (group of groupedPartners; track group) {
            <swiper-slide>
              <div class="slide-wrapper">
                @for (img of group; track img) {
                <img [src]="img.path"
                [style.height]="
                footerData.domain === 'latinacalcio'
              ? '80px'
                : footerData.domain === 'parcoeldorado'
                ? '55px'
              : img.path === 'assets/images/custom-ecommerce-img/pescaracalcio/partnersImg/cata.png'
              ? '30px'
              : '25px'"
                
                >
                }
              </div>
            </swiper-slide>
            }
            </swiper-container>
        }
      </div>
      <div class="client-section mb-20 mt-20"  [ngClass]="{'gap-30' : footerData.footer?.hasextraSection}">
        <div [ngClass]="!isWebMobile && !footerData.footer?.hasextraSection ? 'mr-40' : 'mb-20'"> <img [src]="footerData.footer.clientIcon" alt="" id="clientImg" [ngClass]="{'logo-potenzacalcio': footerData.domain === 'potenzacalcio'}"> </div>
        <div class="d-flex align-items-center" [ngClass]="!isWebMobile && !footerData.footer?.hasextraSection ? 'mr-40' : 'mb-20'" id="share">
          @for (social of footerData.footer.social; track social) {
            <a class="cursor-pointer" (click)="redirectto(social.url)">
              <object [data]="sanitizedPaths[social.url]" type="image/svg+xml" class="social-icon" #svgObject (load)="onSvgLoad(svgObject, footerData.footer.socialIconsColor)" style="pointer-events: none;"></object>
            </a>
          }
        </div>
        <div class="clinet-url" [ngClass]="{'extra-section-url' : footerData.footer?.hasextraSection}">
          @for (privacy of footerData.footer.customClientUrl; track privacy) {
            <a target="_blank" [href]="privacy.url" class="text-capitalize fz-12" [ngClass]="{'mx-10 my-5' : !footerData.footer?.hasextraSection}">
              {{ privacy.label | translate }}
           </a>
          }
        </div>
        <div class="d-flex" [ngClass]="isWebMobile ? 'align-items-center flex-column' : 'mb-5'" *ngIf="footerData.footer?.hasextraSection">
      <div class="d-flex flex-column" [ngClass]="isWebMobile ? 'align-items-center' : ''">
        <div class="mb-10 not-include text-capitalize fw-600"   [ngStyle]="{'color' : footerData.footer.socialIconsColor}" > {{ footerData.footer.extraSectionLabel | translate }}</div>
        <a *ngFor="let social of footerData.footer.extraSection" class="fz-12">
          {{social.label}}
        </a>
        
        <div *ngIf="footerData.footer?.extraSectionFooter" class="mt-10 not-include d-flex align-items-center cursor-pointer fw-600" [ngClass]="isWebMobile ? 'justify-content-center' : ''"  (click)="redircttoPath(footerData.footer.extraSectionFooter.path)" [ngStyle]="{'color' : footerData.footer.socialIconsColor}" >
          {{ footerData.footer.extraSectionFooter.label | translate }}
          <span class="material-symbols-outlined" [ngStyle]="{'color' : footerData.footer.socialIconsColor}">
          chevron_right
          </span></div>
        </div>
        <div *ngIf="footerData.footer?.extraSectionTime"  [ngClass]="isWebMobile ? 'text-center mt-15' : ''">
          <div  class="fw-600">Apertura</div>
          <a class="fz-12" *ngIf="footerData.footer?.extraSectionTime" innerHTML="{{footerData.footer.extraSectionTime | translate}}"></a>
        </div>
    </div> 

      </div>
      <span class="separatorCustom" [ngStyle]="{'background-color' : footerData.footer.socialIconsColor}" ></span>
      <div class="ct-section mb-40">
        <div [ngClass]="!isWebMobile ? 'mr-10' : ''"> <img [src]="footerData.footer.ciaoTicketsImg" alt="" style="height: 40px;">   </div>
        
   
        <div class="d-flex align-items-center" [ngClass]="!isWebMobile && !footerData.footer?.hasextraSection ? 'mr-40' : 'mb-10 mt-10'" id="share">
          @for (social of footerData.footer.socialCt; track social) {
            <a class="cursor-pointer" (click)="redirectto(social.url)">
              <object [data]="sanitizedPathsCT[social.url]" type="image/svg+xml" class="social-icon" #svgObject (load)="onSvgLoad(svgObject, footerData.footer.socialIconsColor)" style="pointer-events: none;"></object>
            </a>
          }
        </div>
        
        <div class="d-flex align-items-center" [ngClass]="isWebMobile ? 'flex-column mt-10' : ''">
          <a class="iubenda-cs-preferences-link text-capitalize mx-10 my-5 fz-12" href="#"> {{ 'footer.privacy' | translate }} </a>
          @for (privacy of privacyLinks; track privacy.label) {
            <a [href]="privacy.url" class="text-capitalize mx-10 my-5 fz-12">
              {{ privacy.label | translate }}
            </a>
          }
        </div>
      </div>
    </div>
  </footer>